export default "__VITE_ASSET__FCQn9pT$__"